import React from 'react';
import PropTypes from 'prop-types';

export function SignalIcon({ percentage, variant = 'black-and-white' }) {
  return (
    <div className={`meteo-signal-icon ${variant}`}>
      <div
        className="signal-icon-body"
        style={{ width: `${percentage}%` }}
      ></div>
      <div className="signal-icon-bars">
        <div className="signal-icon-bar"></div>
        <div className="signal-icon-bar"></div>
        <div className="signal-icon-bar"></div>
        <div className="signal-icon-bar"></div>
      </div>
    </div>
  );
}
SignalIcon.propTypes = {
  percentage: PropTypes.number.isRequired,
  variant: PropTypes.oneOf(['black-and-white', 'blue-and-yellow']),
};
